import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { UserService } from '../../../services/user.service'
import { BillingService } from '../../../services/billing.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { TransactionDT, TransactionObject } from '../../../models/transaction.model';
// import { WMSValidators } from '../../../shared/validators';

@Component({
    selector: 'dialog-add-missing-transaction',
    templateUrl: 'dialog.addmissing.html',
    styleUrls: ['dialog.addmissing.css']
})
export class AddMissingTransactionDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    errorMessage: string = '';
    searchpnrform: FormGroup;
    transDetailform: FormGroup;
    pnr: string = '';
    loading: boolean = false;
    isSubmit: boolean = false;
    displayedColumns: string[] = [];
    transObjects: TransactionObject[] = [];
    NewSkies_Data: TransactionDT[];
    NewSkiesDataSource = new MatTableDataSource<TransactionDT>(this.NewSkies_Data);
    newskies_selection = new SelectionModel<TransactionDT>(true, []);
    selectedRowIndex: number = -1;

    constructor(public dialogRef: MatDialogRef<AddMissingTransactionDialog>,
        @Inject(MAT_DIALOG_DATA) public formdata: any,
        private userService: UserService,
        private billingService: BillingService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.searchpnrform = new FormGroup({
            searchpnr: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(6), Validators.maxLength(6)])
        });

        if (this.formdata.warrantauthcode === 'SW') {
            this.displayedColumns = ['select', 'pnr', 'carriercode', 'bookingdate',
                'agencycode', 'pukalnumber', 'serviceordno', 'paymentdate',
                'paymenttype', 'currency', 'title', 'firstname', 'lastname', 'firstsector',
                'secondsector', 'basefare', 'airporttax', 'insurance', 'adminfee', 'vat',
                'fuelsurcharge', 'noluranwajibjasa', 'servicescharge', 'paymentamount'];
        } else {
            this.displayedColumns = ['select', 'pnr', 'carriercode', 'bookingdate',
                'agencycode', 'pukalnumber', 'serviceordno', 'objectcode', 'paymentdate',
                'paymenttype', 'currency', 'title', 'firstname', 'lastname', 'firstsector',
                'secondsector', 'basefare', 'airporttax', 'insurance', 'adminfee', 'vat',
                'fuelsurcharge', 'noluranwajibjasa', 'servicescharge', 'paymentamount'];

            let getjanobject_sub = this.billingService.getJANObjectList()
                .subscribe(
                    (value) => {
                        this.loading = false;
                        if (value.status === 204) {
                        } else if (value.status === 200) {
                            this.transObjects = value.body;
                        } else {
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(getjanobject_sub);
        }

        this.transDetailform = new FormGroup({
            id: new FormControl({ value: '', disabled: true }),
            carrierCode: new FormControl({ value: '', disabled: true }),
            bookingDate: new FormControl({ value: '', disabled: true }),
            agencyCode: new FormControl({ value: '', disabled: false }, [Validators.required]),
            pukalNumber: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(15)]),
            serviceOrdNo: new FormControl({ value: '', disabled: false }, [Validators.required]),
            objectCode: new FormControl({ value: '', disabled: false }, [Validators.required]),
            paymentDate: new FormControl({ value: '', disabled: true }),
            paymentType: new FormControl({ value: '', disabled: true }),
            currencyCode: new FormControl({ value: '', disabled: true }),
            title: new FormControl({ value: '', disabled: true }),
            firstName: new FormControl({ value: '', disabled: true }),
            lastName: new FormControl({ value: '', disabled: true }),
            firstSector: new FormControl({ value: '', disabled: true }),
            secondSector: new FormControl({ value: '', disabled: true }),
            baseFare: new FormControl({ value: '', disabled: true }),
            airportTax: new FormControl({ value: '', disabled: true }),
            insurance: new FormControl({ value: '', disabled: true }),
            adminFee: new FormControl({ value: '', disabled: true }),
            vat: new FormControl({ value: '', disabled: true }),
            fuelSurcharge: new FormControl({ value: '', disabled: true }),
            noLuranWajibJasa: new FormControl({ value: '', disabled: true }),
            servicesCharge: new FormControl({ value: '', disabled: true }),
            paymentAmount: new FormControl({ value: '', disabled: true })
        });
    }

    trimText() {
        this.searchpnrform.setValue({
            searchpnr: this.searchpnrform.get('searchpnr')!.value.trim()
        });
    }

    onSubmitSearchPNR(form: FormGroup) {
        this.loading = true;

        let search_sub = this.billingService.getTransactionInNewSkies(form.value.searchpnr)
            .subscribe(
                (value) => {
                    this.loading = false;
                    if (value.status === 204) {
                        this.openSnackBar('Error code 204.', '');
                    } else if (value.status === 200) {
                        if (typeof (value.body) === 'string') {
                            this.NewSkiesDataSource = new MatTableDataSource<TransactionDT>();
                            this.openSnackBar(value.body, '');
                        } else if (typeof (value.body) === 'object') {
                            this.NewSkies_Data = value.body;
                            this.NewSkiesDataSource = new MatTableDataSource<TransactionDT>(this.NewSkies_Data);

                            // Set checkbox if Check value is true
                            for (let i = 0; i < this.NewSkiesDataSource.data.length; i++) {
                                if (this.NewSkiesDataSource.data[i].Check == true) {
                                    this.newskies_selection.select(this.NewSkiesDataSource.data[i]);
                                }
                            }
                        }
                    } else {
                        this.openSnackBar('Error occur.', '');
                    }
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(search_sub);
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.newskies_selection.selected.length;
        const numRows = this.NewSkiesDataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.newskies_selection.clear() :
            this.NewSkiesDataSource.data.forEach(row => this.newskies_selection.select(row));
    }

    onHovering(n: any) {
        //console.log(n);
    }

    onUnovering(n: any) {
        //console.log(n);
    }

    // selected value
    selectedRow(n: TransactionDT) {
        this.selectedRowIndex = n.ID;

        this.transDetailform.setValue({
            id: n.ID,
            carrierCode: n.Aline_Id,
            bookingDate: n.Booking_Dt,
            agencyCode: n.Agency_Code,
            pukalNumber: n.Acc_No,
            serviceOrdNo: n.Serial_No,
            objectCode: n.Obj_Id,
            paymentDate: n.Pymnt_Dt,
            paymentType: n.Pymnt_Type,
            currencyCode: n.Currency_Code,
            title: n.Title,
            firstName: n.Psg_First_Name,
            lastName: n.Psg_Last_Name,
            firstSector: n.Sec_1,
            secondSector: n.Sec_2,
            baseFare: n.Base_Fare_Amt,
            airportTax: n.Air_Port_Tax,
            insurance: n.Insurance,
            adminFee: n.Admin_Fee,
            vat: n.Vat,
            fuelSurcharge: n.Fuel_Surcharge,
            noLuranWajibJasa: n.No_Luran_Wajib_Jasa,
            servicesCharge: n.Services_Charge,
            paymentAmount: n.Pymnt_Amt
        });

        this.transDetailform.get('agencyCode').markAsTouched();
        this.transDetailform.get('pukalNumber').markAsTouched();
        this.transDetailform.get('serviceOrdNo').markAsTouched();
        this.transDetailform.get('objectCode').markAsTouched();
    };

    onSubmitTransDetail(form: FormGroup) {
        let checkValidPukalSub = this.billingService.checkAddTransValidPukalNumber(form.value.pukalNumber)
            .subscribe(
                (value) => {
                    this.loading = false;
                    if (value.status === 204) {
                    } else if (value.status === 200) {
                        if (value.body === 1) {
                            let id = this.transDetailform.get('id')!.value;
                            let result = this.NewSkiesDataSource.data.find(function (element) {
                                return element.ID === id;
                            });

                            if (result === undefined) {
                                this.openSnackBar('Error. Data source is empty.', '');
                            } else {
                                let index = this.NewSkiesDataSource.data.indexOf(result);
                                result.Agency_Code = this.transDetailform.get('agencyCode')!.value;
                                result.Acc_No = this.transDetailform.get('pukalNumber')!.value;
                                result.Serial_No = this.transDetailform.get('serviceOrdNo')!.value;

                                let selectedObjectCode = this.transDetailform.get('objectCode')!.value;
                                let selectedObject = this.transObjects.find(function (element) {
                                    return element.Obj_Id === selectedObjectCode;
                                });
                                if (selectedObject !== undefined) {
                                    result.Obj_Id = selectedObject.Obj_Id;
                                    result.Obj = selectedObject.Obj_Id_Map.toString();
                                }

                                this.NewSkiesDataSource.data[index] = result;
                                this.openSnackBar('Transaction saved.', '');
                            }
                        } else if (value.body === -1) {
                            this.openSnackBar('Invalid Pukal Number.', '');
                        } else {
                            this.openSnackBar('Check valid pukal number failed.', '');
                        }
                    } else {
                    }
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(checkValidPukalSub);
    }

    addSelectedTrans() {
        let cfm = confirm("Are you sure you want to add the selected transaction(s)?");

        if (cfm) {
            this.isSubmit = true;
            this.loading = true;
            let addTransactionsSub = this.billingService.addTransactions(this.newskies_selection.selected)
                .subscribe(
                    (value) => {
                        this.isSubmit = false;
                        this.loading = false;

                        if (value.status === 204) {
                        } else if (value.status === 200) {
                            if (value.body === 1) {
                                this.openSnackBar('Selected transaction(s) for ' + this.searchpnrform.get('searchpnr')!.value + ' added.', '');
                                this.dialogRef.close('Transaction saved');
                            } else if (value.body === -1) {
                                this.openSnackBar('Add selected transactions failed.', '');
                            } else {
                                this.openSnackBar('Add selected transactions failed.', '');
                            }
                        } else {
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(addTransactionsSub);
        }
    }

    CheckData() {
        let result = this.newskies_selection.hasValue();
        if (this.newskies_selection.hasValue()) {
            for (let i = 0; i < this.newskies_selection.selected.length; i++) {
                if (this.newskies_selection.selected[i].Agency_Code.trim() === "" ||
                    this.newskies_selection.selected[i].Acc_No.trim() === "" ||
                    this.newskies_selection.selected[i].Serial_No.trim() === ""
                ) {
                    return true;
                }
            }

            return false;
        }
        return true;
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}